import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { observer } from "mobx-react";
import { getSnapshot } from "mobx-state-tree";
import { Col, Form, Row } from "react-bootstrap";

import { useAppStore } from "../../../providers/AppStoreProvider";
import { useAPI } from "../../../providers/ApiProvider";
import { toastWithAsyncFetch } from "../../../utils/helper";
import { VideoForm } from "./VideoForm";
import { QuizForm } from "./QuizForm";

const LESSON_TYPES = [
  { id: 1, model: "video", icon: "fa-video", text: "Video" },
  { id: 2, model: "document", icon: "fa-book-open", text: "Bài đọc" },
  { id: 3, model: "quiz", icon: "fa-square-question", text: "Bộ câu hỏi" },
];

export const ContentForm = observer(
  forwardRef(({ currentLesson }, ref) => {
    const api = useAPI();
    const [lessonType, setLessonType] = useState(currentLesson.lesson_type);
    const videoFormRef = useRef();

    useImperativeHandle(ref, () => {
      switch (currentLesson.lesson_type) {
        case "video":
          return videoFormRef.current;
        case "document":
        case "quiz":
          return null;
      }
    });

    const changeLessonTypeHanldler = (type) => {
      if (lessonType === type || !currentLesson) return;

      // TODO: Show Warning
      // NOTE: Hiện tại chỉ cho select Video
      if (type === "document") {
        return;
      }

      toastWithAsyncFetch(
        {
          loading: "Đang thay đổi dạng bài học...",
          success: "Chọn dạng bài học thành công",
          error: "Thay đổi dạng bài hoc thất bại",
        },
        () =>
          api.callApi("changeLessonType", {
            params: { pk: currentLesson.id },
            body: { lesson_type: type },
          }),
        (res) => {
          const { lesson_type, model_id, quiz } = res.data.data.lesson;
          const content = {};

          content[lesson_type] = { id: model_id };

          setLessonType(lesson_type);
          currentLesson.update({ lesson_type, model_id, ...content, quiz });
        },
      );
    };

    return (
      <>
        <Form.Group className="mt-4">
          <Form.Label className="fw-bold mb-3">Dạng bài học</Form.Label>
          <Row className="g-3">
            {LESSON_TYPES.map((type) => (
              <Col key={`type-${type.id}`}>
                <div
                  role="button"
                  className="lesson-type-selector d-flex justify-content-center align-items-center rounded-10 p-4"
                  data-active={lessonType === type.model}
                  // @NOTE: Hiện tại chỉ cho select Video
                  disabled={type.model === "document"}
                  onClick={changeLessonTypeHanldler.bind(null, type.model)}
                >
                  <i className={`fa-light ${type.icon} fa-lg me-3`} />
                  {type.text}
                </div>
              </Col>
            ))}
          </Row>
        </Form.Group>

        {lessonType === "video" && <VideoForm ref={videoFormRef} currentLesson={currentLesson} />}

        {lessonType === "quiz" && <QuizForm />}
      </>
    );
  }),
);
